<template>
  <section class="pt-0">
    <div id="home_section" class="home-section multi-slider">
      <!--<div class="single-image" v-if="!customizationLocal.slider_availability"
           v-bind:style="{
              backgroundImage: `url(${applySliderImage})`,
            }"
      ></div>-->
      <img
        class="single-image"
        v-if="!customizationLocal.slider_availability"
        alt=""
        :src="applySliderImage"
      />
      <div v-else>
        <offers-single-slider
          :offers="all_brand_website_banners"
          v-if="!customizationLocal.slider_multiimage"
        />
        <offers-slider
          :offers="getFilteredOffers"
          v-if="customizationLocal.slider_multiimage"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import OffersSlider from './OffersSlider'
import OffersSingleSlider from './OffersSingleSlider'
export default {
  name: 'Offers',
  components: { OffersSlider, OffersSingleSlider },
  computed: {
    ...mapGetters([
      '_T',
      'getFilteredOffers',
      'customizationLocal',
      'all_brand_website_banners',
    ]),
    applySliderImage() {
      let brandBanner = this.all_brand_website_banners
      if (window.matchMedia('(max-width: 500px)').matches) {
        if (
          brandBanner[0].slider_offer_image_m &&
          brandBanner[0].slider_offer_image_m.length
        ) {
          return brandBanner[0].slider_offer_image_m
        } else return brandBanner[0].slider_offer_image
      } else return brandBanner[0].slider_offer_image
    },
  },
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.home-section {
  .single-image {
    width: 100%;
    height: $px600;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    display: block;
  }

  .slider-section,
  .image-only,
  .slider-multiple {
    display: none;
  }
  &.single_slider {
    .slider-section {
      display: block;
    }
  }
  &.image_only {
    .image-only {
      display: block;
    }
  }
  &.multi-slider {
    .slider-multiple {
      display: block;
    }
  }
}
@media (max-width: 575px) {
  .home-section {
    border-top: $px12 solid $light-border;
    .single-image {
      max-width: 100%;
      height: auto;
    }
  }
}
</style>
